import { disableHotspotIcon } from '../state/ui-store';

export const disableHotspotBttn = () => disableHotspotIcon();
